/**
 * #193 — mise en forme de la liste « À rappeler ». Module PUR (ni React ni
 * i18next) : la langue est passée par l'appelant (`i18n.language`, jamais
 * celle du navigateur — même règle que le reste de la scène).
 */

/**
 * Numéro LISIBLE sur iPad. Un E.164 nu (`+33612345678`) se relit mal au
 * moment de vérifier qui l'on rappelle ; on groupe les chiffres sans jamais
 * les modifier (ce qui part à la composition reste le numéro d'origine).
 *  - France et DOM (`+33`, `+262`, `+590`, `+594`, `+596`) : indicatif, puis
 *    1 chiffre, puis des paires — `+33 6 12 34 56 78` ;
 *  - autres pays : indicatif laissé collé, chiffres par groupes de 3.
 */
const FR_LIKE = /^\+(33|262|590|594|596)(\d)(\d{2})(\d{2})(\d{2})(\d{2})$/

export function formatCallbackNumber(e164: string): string {
  const value = e164.trim()
  const french = FR_LIKE.exec(value)
  if (french) return `+${french.slice(1).join(' ')}`
  if (!/^\+\d+$/.test(value)) return value
  const digits = value.slice(1)
  const head = digits.slice(0, digits.length % 3 || 3)
  const rest = digits.slice(head.length).match(/\d{3}/g) ?? []
  return `+${[head, ...rest].join(' ')}`
}

const UNITS: Array<{ unit: Intl.RelativeTimeFormatUnit; seconds: number }> = [
  { unit: 'day', seconds: 86400 },
  { unit: 'hour', seconds: 3600 },
  { unit: 'minute', seconds: 60 },
]

/** « il y a 12 min » / « 12 min. ago » — relatif, dans la langue active. */
export function formatRelativeTime(iso: string, language: string, now: number = Date.now()): string {
  const elapsed = Math.max(0, Math.round((now - new Date(iso).getTime()) / 1000))
  const format = new Intl.RelativeTimeFormat(language, { numeric: 'always', style: 'short' })
  for (const { unit, seconds } of UNITS) {
    if (elapsed >= seconds) return format.format(-Math.floor(elapsed / seconds), unit)
  }
  // Sous la minute : « il y a 0 min » se lit mal — on arrondit à 1.
  return format.format(-1, 'minute')
}

/**
 * #396 — RÈGLE D'AFFICHAGE d'une ligne « À rappeler » (décision utilisateur du
 * 2026-10-21) : le NOM SEUL quand le numéro a une fiche nommée (le numéro
 * passe en infobulle et dans le nom accessible), le NUMÉRO SEUL sinon.
 * Rend le nom à afficher, ou `null` pour « montrer le numéro ». Un nom vide
 * ou fait de blancs vaut « pas de nom » (le serveur écarte déjà « Inconnu »).
 */
export function callbackContactName(item: { contactName?: string | null }): string | null {
  const name = typeof item.contactName === 'string' ? item.contactName.trim() : ''
  return name ? name : null
}
